/**
 * 基本配置
 */
const settings = {
	webName: '上海技术交易所（上饶）创新服务工作站',
	webNameLogin: '区域科创服务平台',
	webNameEN: 'STEX INNOVATION SERVICE WORKSTATION',
	//localStorage 存储前缀
	storagePrefix: 'region_',
	//本地测试域名
	// baseUrl: 'http://www.sjs.com/',
	//baseUrl: 'http://121.37.142.117:9202/',
	baseUrl: 'https://isw.stexinfo.com/',
	//真实环境七牛云存储域名
	qnUrl: 'https://rsatss2qiniu.shenbaoyuan.com/',
	qnActionUrl: 'https://up-cn-east-2.qiniup.com',
	qnUrlSubo: 'https://qnsubo.shenbaoyuan.com/',//部分来源于苏博的文件，显示文件的时候使用该地址，该地址仅作为显示，不做上传地址
	//请求接口
	apiUrl: 'api/',
	//路由白名单
	whiteUrl: ['/login','/login2'],
	//临时菜单
	menuUrl: [
		/* {
			id: 1,
			pid: 0,
			name: '首页',
			icon: 'icon_sy',
			path: '/platform',
			child: [],
			nomenuchild: [
				{ id: 300, pid: 1, name: '首页-南京江北新区中央商务区', icon: '', path: '/jbxqzyswq', child: [], nomenuchild: [], routerstatus: 1 },
				{ id: 301, pid: 1, name: '首页-南京江宁高新区', icon: '', path: '/jngxq', child: [], nomenuchild: [], routerstatus: 1 },
				{ id: 302, pid: 1, name: '首页-滁州南谯区', icon: '', path: '/cznqq', child: [], nomenuchild: [], routerstatus: 1 },
				{ id: 303, pid: 1, name: '首页-盐城射阳县', icon: '', path: '/ycsyx', child: [], nomenuchild: [], routerstatus: 1 }
			],
			routerstatus: 1
		} */
	],
	//临时用户信息
	/* userInfo: {
		id: 12,
		name: '南京市江宁区高新园',
	}, */
	//百度地图ak
	baiduMapAK: 'ZshllODlLGL0OcTh5nElEgIR9oN6kn2R',
	//当前年份
	curYear: (new Date()).getFullYear(),
	//省份对应的坐标
	c0xyPoint: {
		//安徽top216 left391  文字top301  left219
		'chan505': { py: 216, px: 391, wy: 301, wx: 219 },
		//江苏top210 left422  文字top295  left250
		'chan508': { py: 210, px: 422, wy: 295, wx: 250 },
		//山东top168 left400  文字top253  left228
		'chan506': { py: 168, px: 400, wy: 253, wx: 228 },
		//浙江top250 left420  文字top335  left248
		'chan510': { py: 250, px: 420, wy: 335, wx: 248 },
	},
	qiyeweixin_appid: '',
	qiyeweixin_agentid: '',
}

export default settings;